import { matchPath, useLocation } from 'react-router-dom';
import { useMediaQuery, useTheme } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';

/** Az alsó navigációs sáv magassága (px), safe-area nélkül. */
export const BOTTOM_NAV_HEIGHT = 56;

/** Útvonalak, ahol az alsó sáv nem jelenik meg (a szerkesztőnek saját mobil vezérlői vannak). */
export const BOTTOM_NAV_HIDDEN_PATHS = ['/gardens/new', '/gardens/:id/edit'];

export const isBottomNavHiddenPath = (pathname: string): boolean =>
  BOTTOM_NAV_HIDDEN_PATHS.some((pattern) => matchPath({ path: pattern, end: true }, pathname) !== null);

/**
 * Egyetlen közös szabály arra, mikor látszik a mobil alsó navigációs sáv:
 * `md` alatti szélesség, bejelentkezett felhasználó, és nem szerkesztő oldal.
 * Az App (tartalom alatti térköz) és a MobileBottomNav ugyanezt használja.
 */
export const useBottomNavVisible = (): boolean => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
  const { user } = useAuth();
  const location = useLocation();

  return isMobile && !!user && !isBottomNavHiddenPath(location.pathname);
};

export default useBottomNavVisible;
